<template>
<div class="chapter">
<div class="inner_page">
<p class="ack-head"><i>Acknowledgments</i></p>
<p class="noindentt">My wholehearted thanks goes to Amy Marson and the entire team at C&amp;T Publishing—my editors Michele Fry, Joanna Burgarino, Alison Schmidt, Katie Van Amburg, and Nan Powell; my book designer Katie McIntosh and cover designer Kristy Zacharias; the photography team of Nissa Brehmer, Diane Pedersen, and Mary Peyton Peppo; production coordinator Freesia Pearson Blizard; illustrator Jenny Davis; and of course Roxane Cerda and Gailen Runge.</p>
<p class="noindentt">Also thanks to the wonderful companies that manufacture the fabrics that I used to create the pieces for this book: Art Gallery Fabrics, Blend Fabrics, Riley Blake Fabrics, and Robert Kaufman Fabrics. The talented designers whose fabrics I was fortunate enough to play with are listed in Resources.</p>
<p class="noindentt">A heartfelt thanks goes to Aurifil and the Warm Company. Aurifil threads come in a wonderful array of colors and are such a pleasure with which to sew! All the quilts feature Warm &amp; White batting—my favorite!</p>
<p class="noindentt">And last but not least I’d like to thank BERNINA. It is a pleasure to sew each and every stitch using your wonderful machines. Thanks for your support.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_ack.vue?7429e0a3